export const ENDPOINTS = {
  PUBLIC_SENDGRID_SENDEMAIL: '/public/sendGrid/sendEmail',
  STORE_CC_QUIZ: 'quiz/store-CC-quiz',
  EMAIL_CC_QUIZ: 'public/quiz-email',
  SWIFT_REPORT_DOWNLOAD: 'marketing/download-report',
  SWITCH_TO_STATRYS: 'marketing/switch-to-statrys',
  TEST_YOUR_ACCOUNT_QUIZ: 'quiz/test-your-account-quiz',
  COUNTRIES_LIST: 'countries/list'
};
